var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"activator activator-iceberg",style:(`background-color: ${_vm.color}`),on:{"mousedown":function($event){return _vm.startMouseMove($event)},"mouseup":function($event){return _vm.endMouseMove()}}},[_c('div',{staticClass:"activator-iceberg-object"})])
}
var staticRenderFns = []

export { render, staticRenderFns }